import React, { useState, useEffect } from 'react'

import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Table,
  Modal,
  Checkbox,
  Space,
} from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { SearchOutlined } from '@ant-design/icons'

import { getCookie } from 'helper/cookie'

import {
  updateCheckList,
  saveCheckList,
  deleteCheckList,
  getResultCheckList,
  optionCheckList,
} from 'api/Project/checklist'
import {
  CarryOutOutlined,
  LeftOutlined,
  BellOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
  FastBackwardFilled,
  PauseCircleTwoTone,
  CloseCircleOutlined,
} from '@ant-design/icons'

import AddCheckList from '../Checklist/addsubchecklist/addchecklist'
import iconEmpty from 'icons/createproject/EmptySprintFlow.svg'
import lang from 'lang/en'
const Container = styled.div`
  background-color: ${ColorList.white};

  // width: 100;
  height: auto;
  // margin-top: 16px;
  // margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}

const AddSubTaskKPIFinance = (props) => {
  // console.log(props.id)

  ///lang
  const language = getCookie('lang')
  const word = lang[language]

  const { swithCaseTaskFLowFunction, role, idEditPRJ } = props
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  const [form2] = Form.useForm()

  ///checklist
  const [dataCheckList, setDataCheckList] = useState(initalState.data)
  const [modalVisionaddChecklist, setModalVisionaddChecklist] = useState()
  const [checklistreq, setChecklistreq] = useState(false)
  const [ModalVision, setModalVision] = useState(false)
  const [idEdit, setIdEdit] = useState(false)
  const [checkreq, setCheckReq] = useState(Boolean)
  const [dataOptionChecklist, setDataOptionChecklist] = useState(initalState.data)

  //modal Delete Checklist
  const [visibleModalDelete, setVisibleModalDelete] = useState()
  const [dataDeleteChecklist, setDataDeleteChecklist] = useState()

  ///checklist
  const getDataCheckList = async () => {
    await getResultCheckList({
      sprintflow_id: props.idsubtask,
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        // console.log(response)
        const { status, data, error } = response

        if (error) {
          await setDataCheckList([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataCheckList(data)
          await setIsLoading(false)
        } else {
          setDataCheckList([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataCheckList([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getDataOptionCheckList = async () => {
    await optionCheckList({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setDataOptionChecklist([])
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataOptionChecklist(data)
          await setIsLoading(false)
        } else {
          setDataOptionChecklist([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataOptionChecklist([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const onchecklist = (e, rec) => {
    // console.log(e.target.checked)
    setChecklistreq(e.target.checked)
    let reqcheck

    if (e.target.checked == true) {
      reqcheck = 'Y'
    } else {
      reqcheck = 'N'
    }

    const dataArray = {
      project_id: parseInt(idEditPRJ),
      id: rec.key,
      title: rec.name,
      checklist_type_id: rec.typeID,
      required: reqcheck,
    }
    try {
      updateCheckList({
        params: dataArray,
        token: token,
      }).then((response) => {
        if (response.status === 200) {
          getDataCheckList()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const funcDeleteChecklist = (record) => {
    setVisibleModalDelete(true)
    setDataDeleteChecklist(record)
  }

  const handleOkDeleteChecklist = () => {
    if (role == true) {
    } else {
      const dataArraydeleteChecklist = {
        id: dataDeleteChecklist.key,
        project_id: parseInt(idEditPRJ),
      }
      try {
        deleteCheckList({
          params: dataArraydeleteChecklist,
          token: token,
        }).then((response) => {
          if (response.status === 200) {
            setVisibleModalDelete(false)
            getDataCheckList()
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const EventUseModal = async (rec) => {
    props.setCheckbtn('btnchecklist')
    if (role == true) {
    } else {
      setModalVision(true)
      setIdEdit(rec.key)
      if (rec.required == 'Y') {
        rec.required = true
        await setChecklistreq(true)
      } else {
        rec.required = false
        await setChecklistreq(false)
      }

      // console.log(rec.required)

      setCheckReq(rec.required)
      form2.setFieldsValue({
        selectchecklist: rec.typeID,
        namechecklist: rec.name,
        reqchecklist: rec.required,
      })
    }
  }

  const handleCancelEditChecklist = () => {
    props.setCheckbtn('')
    setModalVision(false)
  }

  const changeChecked = (e) => {
    console.log(e.target.checked)
    setCheckReq(!checkreq)
    form2.setFieldsValue({
      reqchecklist: e.target.checked,
    })
  }

  useEffect(() => {
    if (token) {
      getDataCheckList()
      getDataOptionCheckList()
    }
  }, [token, props.idsubtask, props.canclemodal])

  //Table CheckList
  const dataSource = dataCheckList.map((item) => ({
    key: item.id,
    name: item.title,
    type: item.checklist_type,
    typeID: item.checklist_type_id,
    required: item.required,
  }))

  const columns = [
    {
      title: word['addtask_information_title_checklist_name'],
      dataIndex: 'name',
      key: 'name',
      // width: 250,
    },
    {
      title: word['addtask_information_title_checklist_type'],
      dataIndex: 'type',
      key: 'type',
      // width: 200,
    },
    {
      title: word['addtask_information_title_checklist_req'],
      dataIndex: 'required',
      key: 'required',
      align: 'center',
      // width: 260,
      render: (text, record, index) => {
        var valuecheck = true
        if (text == 'Y') {
          valuecheck = true
        } else {
          valuecheck = false
        }
        if (role == true) {
          return (
            <Space style={{ height: 12 }}>
              <Checkbox
                id={index}
                disabled
                checked={valuecheck}
                onChange={(event) => onchecklist(event, record)}
              ></Checkbox>
            </Space>
          )
        } else {
          return (
            <Space style={{ height: 12 }}>
              <Checkbox
                id={index}
                checked={valuecheck}
                onChange={(event) => onchecklist(event, record)}
              ></Checkbox>
            </Space>
          )
        }
      },
    },
    {
      title: word['addtask_information_title_checklist_action'],
      key: 'action',
      align: 'center',
      render: (text, record, index) => {
        return (
          <div>
            <a id={'edit' + index}>
              <EditOutlined
                style={{ color: '#7C7C84', cursor: role == true ? 'no-drop' : 'unset' }}
                onClick={() => EventUseModal(record)}
              />
            </a>
            <a style={{ marginLeft: 36 }} id={'edit' + index}>
              <DeleteOutlined
                style={{ color: '#7C7C84', cursor: role == true ? 'no-drop' : 'unset' }}
                onClick={() => funcDeleteChecklist(record)}
              />
            </a>
          </div>
        )
      },
    },
  ]

  const onFinishEditCheckList = (values) => {
    console.log(values.reqchecklist)

    if (values.reqchecklist == true) {
      values.reqchecklist = 'Y'
    } else {
      values.reqchecklist = 'N'
    }

    const dataArrayEditCheckList = {
      id: idEdit,
      project_id: parseInt(idEditPRJ),
      title: values.namechecklist,
      checklist_type_id: values.selectchecklist,
      required: values.reqchecklist,
    }
    // console.log(dataArrayEditCheckList)

    updateCheckList({
      params: dataArrayEditCheckList,
      token: token,
    }).then(async (response) => {
      if (response.status === 200) {
        props.setCheckbtn('')
        setModalVision(false)
        getDataCheckList()
      }
    })
  }

  const checklistadd = () => {
    props.setCheckbtn('btnchecklist')
    setModalVisionaddChecklist(true)
  }

  const onCancelModal = () => {
    getDataSubTask()
    props.handleCancelAddTask()
  }
  const checkemptychecklist = (data, checkbtn) => {
    // console.log(data.length)
    if (data.length == 0) {
      return (
        <div style={{ marginTop: 83 }}>
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={iconEmpty}></img>
            <h2 style={{ marginTop: 33 }} className="coloremptychecklist">
              {word['addtask_information_word_checklist_create']}
            </h2>
            <Button
              id="CreatNew"
              disabled={checkbtn}
              className="BTN_ClassA"
              onClick={() => checklistadd('-', 'add')}
              style={{ width: 135, marginTop: 32 }}
            >
              <PlusOutlined className="Icon-color" />
              {word['addtask_information_btn_checklist_create']}
            </Button>
          </div>
        </div>
      )
    } else {
      return (
        <div style={{ marginTop: 36 }}>
          <Row
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h4>{word['addtask_information_title_checklist_checklist']}</h4>

            <Button
              id="AddNew"
              disabled={checkbtn}
              className="BTN_ClassA"
              onClick={() => checklistadd('-', 'add')}
              style={{ width: 135 }}
            >
              <PlusOutlined className="Icon-color" />
              {word['addtask_information_btn_checklist_addnew']}
            </Button>
          </Row>
          <Table
            className="tableassignee"
            // className="Table tablesprinttask"
            style={{ marginTop: 32 }}
            columns={columns}
            dataSource={dataSource}
            pagination={false}
          />
        </div>
      )
    }
  }

  if (role == true) {
    return (
      <Container>
        <Col span={24} className="displayemailchecklist">
          {checkemptychecklist(dataCheckList, true)}
        </Col>

        <AddCheckList
          setCheckbtn={props.setCheckbtn}
          modalVisionaddChecklist={modalVisionaddChecklist}
          setModalVisionaddChecklist={setModalVisionaddChecklist}
          getDataCheckList={getDataCheckList}
          id={props.idsubtask}
        />
        <Modal
          maskClosable={false}
          className="checklistmodal"
          title={
            <h2 style={{ color: '#127EC3' }}>
              {word['addtask_information_title_modal_checklist']}
            </h2>
          }
          visible={ModalVision}
          onOk={form2.submit}
          onCancel={handleCancelEditChecklist}
          okText="Save"
        >
          <Form form={form2} name="EditChecklist" onFinish={onFinishEditCheckList}>
            <h4>{word['addtask_information_title_modal_checklist_type']}</h4>
            <div style={{ paddingTop: 8 }}>
              <Form.Item
                name="selectchecklist"
                rules={[
                  {
                    required: true,
                    message: word['addtask_information_checklist_Type_Checklist'],
                  },
                ]}
              >
                <Select placeholder="Type Checklist" style={{ width: 586 }} size="large">
                  {dataOptionChecklist.map((item) => (
                    <Option value={item.id}>{item.name_en}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <h4 style={{ paddingTop: 24 }}>
              {word['addtask_information_title_modal_checklist_name']}
            </h4>
            <div style={{ paddingTop: 8 }}>
              <Form.Item
                name="namechecklist"
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: word['addtask_information_checklist_Name_Checklist'],
                  },
                ]}
              >
                <Input
                  className="input"
                  style={{ width: 586 }}
                  placeholder="Name"
                  size="large"
                ></Input>
              </Form.Item>
            </div>

            <div style={{ paddingTop: 24 }}>
              <Form.Item name="reqchecklist" id="reqchecklist">
                <Checkbox onChange={changeChecked} checked={checkreq}>
                  {word['addtask_information_title_modal_checklist_required']}
                </Checkbox>
              </Form.Item>
            </div>
          </Form>
        </Modal>
      </Container>
    )
  } else {
    return (
      <Container style={{ minHeight: 450 }}>
        <Col span={24} className="displayemailchecklist">
          {checkemptychecklist(dataCheckList, false)}
        </Col>
        <AddCheckList
          setCheckbtn={props.setCheckbtn}
          modalVisionaddChecklist={modalVisionaddChecklist}
          setModalVisionaddChecklist={setModalVisionaddChecklist}
          getDataCheckList={getDataCheckList}
          id={props.idsubtask}
          idEditPRJ={idEditPRJ}
        />
        <Modal
          maskClosable={false}
          className="checklistmodal"
          title={
            <h2 style={{ color: '#127EC3' }}>
              {word['addtask_information_title_modal_checklist']}
            </h2>
          }
          visible={ModalVision}
          onOk={form2.submit}
          onCancel={handleCancelEditChecklist}
          okText="Save"
        >
          <Form form={form2} name="EditChecklist" onFinish={onFinishEditCheckList}>
            <h4>{word['addtask_information_title_modal_checklist_type']}</h4>
            <div style={{ paddingTop: 8 }}>
              <Form.Item
                name="selectchecklist"
                rules={[
                  {
                    required: true,
                    message: word['addtask_information_checklist_Type_Checklist'],
                  },
                ]}
              >
                <Select placeholder="Type Checklist" style={{ width: 586 }} size="large">
                  {dataOptionChecklist.map((item) => (
                    <Option value={item.id}>{item.name_en}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <h4 style={{ paddingTop: 24 }}>
              {word['addtask_information_title_modal_checklist_name']}
            </h4>
            <div style={{ paddingTop: 8 }}>
              <Form.Item
                name="namechecklist"
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: word['addtask_information_checklist_Name_Checklist'],
                  },
                ]}
              >
                <Input
                  className="input"
                  style={{ width: 586 }}
                  placeholder="Name"
                  size="large"
                ></Input>
              </Form.Item>
            </div>

            <div style={{ paddingTop: 24 }}>
              <Form.Item name="reqchecklist" id="reqchecklist">
                <Checkbox onChange={changeChecked} checked={checkreq}>
                  {word['addtask_information_title_modal_checklist_required']}
                </Checkbox>
              </Form.Item>
            </div>
          </Form>
        </Modal>

        <Modal
          maskClosable={false}
          className="DeleteModal"
          visible={visibleModalDelete}
          okText={'Delete'}
          onOk={handleOkDeleteChecklist}
          onCancel={() => setVisibleModalDelete(false)}
        >
          <CloseCircleOutlined className="CloseCircleOutlined" />
          <h2>{word['addtask_information_title_modal_delete_checklist_title']}</h2>

          <h4>{word['addtask_information_title_modal_delete_checklist_des']}</h4>
        </Modal>
      </Container>
    )
  }
}
export default AddSubTaskKPIFinance
